(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dmk-complete-look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dmk-complete-look')) {
    customElements.define(
      'dmk-complete-look',
      class DmkCompleteLook extends HTMLElement {
        connectedCallback() {
          this.mainPrice = Number(this.dataset.mainPrice);
          this.partner = this.querySelector('[data-dmk-partner]');
          this.button = this.querySelector('[data-dmk-add]');
          this.error = this.querySelector('.dmk-look__error');
          this.button.addEventListener('click', () => this.add());
          if (this.partner.tagName === 'SELECT') this.partner.addEventListener('change', () => this.reprice());
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const data = event && event.data;
              if (!data || data.sectionId !== this.dataset.section || !data.variant) return;
              this.mainPrice = data.variant.price;
              this.reprice();
            });
          }
        }
        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
        }
        partnerPrice() {
          const el = this.partner.tagName === 'SELECT' ? this.partner.selectedOptions[0] : this.partner;
          return Number(el.dataset.price);
        }
        reprice() {
          const pct = Number(this.dataset.pct) || 0;
          const total = this.mainPrice + this.partnerPrice();
          const pair = Math.round((total * (100 - pct)) / 10000) * 100;
          const fmt = (cents) => Math.round(cents / 100).toLocaleString('en-US');
          const set = (sel, val) => {
            const el = this.querySelector(sel);
            if (el) el.textContent = fmt(val);
          };
          set('[data-dmk-total]', total);
          set('[data-dmk-pair]', pair);
          set('[data-dmk-saving]', total - pair);
        }
        mainVariantId() {
          const input = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
          return input ? input.value : null;
        }
        async add() {
          const mainId = this.mainVariantId();
          if (!mainId) return this.showError('Please choose your size first.');
          this.error.hidden = true;
          this.button.setAttribute('aria-busy', 'true');
          const drawer = document.querySelector('cart-drawer');
          const body = {
            items: [
              { id: Number(mainId), quantity: 1 },
              { id: Number(this.partner.value), quantity: 1 },
            ],
          };
          if (drawer) {
            body.sections = drawer.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
          }
          try {
            const res = await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            });
            const data = await res.json();
            if (!res.ok || data.status) {
              this.showError(data.description || data.message || 'Could not add these pieces. Please try again.');
              return;
            }
            if (drawer && data.sections) {
              drawer.renderContents(data);
            } else {
              window.location.href = this.dataset.cartUrl;
            }
          } catch (e) {
            this.showError('Could not add these pieces. Please try again.');
          } finally {
            this.button.removeAttribute('aria-busy');
          }
        }
        showError(msg) {
          this.error.textContent = msg;
          this.error.hidden = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dmk-mega-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dmk-mega')) {
    customElements.define(
      'dmk-mega',
      class DmkMega extends HTMLElement {
        connectedCallback() {
          this.details = this.closest('details');
          this.tiles = Array.from(this.querySelectorAll('[data-dmk-tile]'));
          this.tiles.forEach((tile) => {
            tile.addEventListener('mouseenter', () => this.select(tile));
            tile.addEventListener('focus', () => this.select(tile));
          });
          if (this.tiles[0]) this.select(this.tiles[0]);
          this.bindHover();
        }

        select(tile) {
          const index = tile.dataset.dmkTile;
          this.tiles.forEach((t) => t.classList.toggle('is-active', t === tile));
          this.querySelectorAll('[data-dmk-preview]').forEach((img) => {
            img.classList.toggle('is-active', img.dataset.dmkPreview === index);
          });
          const name = tile.dataset.name || '';
          const count = tile.dataset.count;
          this.querySelector('[data-dmk-name]').textContent = name;
          this.querySelector('[data-dmk-count]').textContent = count ? `${count} ${count === '1' ? 'piece' : 'pieces'}` : '';
          this.querySelector('[data-dmk-cta]').textContent = `Shop ${name.toLowerCase()} →`;
        }

        // Open on hover on desktop; touch and keyboard keep the normal click behaviour
        bindHover() {
          const details = this.details;
          if (!details || details.dataset.dmkHover) return;
          details.dataset.dmkHover = 'true';
          const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
          const summary = details.querySelector('summary');
          let closeTimer;

          const open = () => {
            clearTimeout(closeTimer);
            if (!details.hasAttribute('open')) {
              details.setAttribute('open', '');
              summary?.setAttribute('aria-expanded', 'true');
            }
          };
          const close = () => {
            closeTimer = setTimeout(() => {
              details.removeAttribute('open');
              summary?.setAttribute('aria-expanded', 'false');
            }, 220);
          };

          details.addEventListener('mouseenter', () => canHover.matches && open());
          details.addEventListener('mouseleave', () => canHover.matches && close());
          summary?.addEventListener('click', (event) => {
            if (!canHover.matches || !details.hasAttribute('open')) return;
            // Already open from hover: keep it open instead of toggling shut
            event.preventDefault();
            open();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dmk-menu-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    // Automatic top seller: the first in-stock product in best-selling order
    const KEY = 'dmkTopSeller';
    const apply = (tile, data) => {
      if (!data || !data.src) return;
      let img = tile.querySelector('.dmk-drawer__tile-in img');
      if (!img) {
        img = document.createElement('img');
        img.alt = '';
        tile.querySelector('.dmk-drawer__glow').after(img);
      }
      img.removeAttribute('srcset');
      img.src = data.src;
    };

    const load = () => {
      const tile = document.querySelector('[data-dmk-auto-top]');
      if (!tile || tile.dataset.dmkLoaded) return;
      tile.dataset.dmkLoaded = 'true';
      try {
        const cached = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (cached) return apply(tile, cached);
      } catch (e) {}

      fetch('/collections/all?sort_by=best-selling&sections=main-collection-product-grid')
        .then((r) => r.json())
        .then((json) => {
          const html = Object.values(json)[0];
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const card = Array.from(doc.querySelectorAll('.grid__item')).find(
            (item) => !/sold out/i.test(item.querySelector('.badge')?.textContent || '') && item.querySelector('img')
          );
          if (!card) return;
          const src = card.querySelector('img').getAttribute('src').replace(/width=\d+/, 'width=900');
          const data = { src };
          try {
            sessionStorage.setItem(KEY, JSON.stringify(data));
          } catch (e) {}
          apply(tile, data);
        })
        .catch(() => {});
    };

    // Fetch when the menu is about to open, so the photo is ready when it shows
    document.addEventListener('pointerdown', (e) => {
      if (e.target.closest('.header__icon--menu')) load();
    });
    document.addEventListener(
      'toggle',
      (e) => {
        if (e.target.id === 'Details-menu-drawer-container' && e.target.open) load();
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dmk-multibuy-nudge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dmk-mb-nudge')) {
    customElements.define(
      'dmk-mb-nudge',
      class DmkMbNudge extends HTMLElement {
        connectedCallback() {
          this.q1 = Number(this.dataset.q1);
          this.p1 = Number(this.dataset.p1);
          this.q2 = Number(this.dataset.q2);
          this.p2 = Number(this.dataset.p2);
          this.excluded = (this.dataset.excluded || '')
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean);
          this.msg = this.querySelector('[data-nudge-msg]');
          this.pill = this.querySelector('[data-nudge-pill]');
          this.bag = this.querySelector('[data-nudge-bag]');
          this.steps = this.querySelectorAll('[data-step]');

          // Phones start as one slim line so it never covers the product; the
          // full card opens on tap, or for a few seconds after she adds a piece.
          this.isPhone = () => window.matchMedia('(max-width: 749px)').matches;
          let min = this.isPhone();
          try {
            const saved = sessionStorage.getItem('dmkNudgeMin');
            if (saved !== null && !this.isPhone()) min = saved === '1';
          } catch (e) {}
          this.render(Number(this.dataset.count));
          this.setMin(min);

          this.querySelector('[data-nudge-min]').addEventListener('click', () => this.setMin(true, true));
          this.querySelector('[data-nudge-open]').addEventListener('click', () => this.setMin(false, true));

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
          }
          window.addEventListener('pageshow', (e) => {
            if (e.persisted) this.refresh();
          });

          document.body.classList.add('dmk-nudge-on');
          this.measure = this.measure.bind(this);
          if ('ResizeObserver' in window) {
            new ResizeObserver(this.measure).observe(this);
          }
          window.addEventListener('resize', this.measure);
          this.addEventListener('transitionend', this.measure);
          if ('MutationObserver' in window) {
            new MutationObserver(() => requestAnimationFrame(this.measure)).observe(document.body, {
              attributes: true,
              attributeFilter: ['class'],
            });
          }
          this.measure();
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
          document.body.classList.remove('dmk-nudge-on');
        }

        measure() {
          const rect = this.getBoundingClientRect();
          const root = document.documentElement;
          root.style.setProperty('--dmk-nudge-top', Math.max(0, window.innerHeight - rect.top) + 'px');
          root.style.setProperty('--dmk-nudge-h', Math.ceil(rect.height + 16) + 'px');
        }

        setMin(min, byUser) {
          clearTimeout(this.autoClose);
          this.classList.toggle('is-min', min);
          if (byUser) {
            try {
              sessionStorage.setItem('dmkNudgeMin', min ? '1' : '0');
            } catch (e) {}
          }
          requestAnimationFrame(() => this.measure());
        }

        refresh() {
          fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
            headers: { Accept: 'application/json' },
          })
            .then((r) => r.json())
            .then((cart) => {
              let count = 0;
              (cart.items || []).forEach((item) => {
                const type = String(item.product_type || '').trim().toLowerCase();
                if (!this.excluded.includes(type)) count += item.quantity;
              });
              const changed = count !== this.count;
              this.render(count);
              if (changed && this.classList.contains('is-min')) {
                // Show the full card so she sees the progress, then fold it back.
                this.setMin(false);
                this.autoClose = setTimeout(() => this.setMin(true), 6000);
              }
            })
            .catch(() => {});
        }

        render(count) {
          this.count = count;
          const { q1, p1, q2, p2 } = this;
          const hasTier2 = q2 > 0 && p2 > 0;
          const word = (n) => (n === 1 ? 'piece' : 'pieces');
          let msg = '';
          let pill = '';

          if (count === 0) {
            msg = hasTier2
              ? `Buy any ${q1}, <b>save ${p1}%</b>. Buy ${q2} or more, <b>save ${p2}%</b>.`
              : `Buy any ${q1} or more, <b>save ${p1}%</b>.`;
            pill = hasTier2 ? `Buy ${q1} save ${p1}% · Buy ${q2} save ${p2}%` : `Buy ${q1} save ${p1}%`;
          } else if (count < q1) {
            const need = q1 - count;
            const all = q1 === 2 ? 'on both' : 'on all';
            msg = `You have ${count} ${word(count)} in your bag. Add <b>${need} more</b> and save <b>${p1}%</b> ${all}.`;
            pill = `${count} in bag. Add ${need} more, save ${p1}%`;
          } else if (hasTier2 && count < q2) {
            const need = q2 - count;
            msg = `<b>${p1}% off</b> is on in your bag. Add <b>${need} more</b> to save <b>${p2}%</b> on all.`;
            pill = `${p1}% on. Add ${need} more for ${p2}%`;
          } else {
            const best = hasTier2 ? p2 : p1;
            msg = `You are saving <b>${best}%</b> on your ${count} pieces.`;
            pill = `Saving ${best}% on ${count} pieces`;
          }

          this.msg.innerHTML = msg;
          this.pill.textContent = pill;
          this.bag.hidden = count === 0;
          this.steps.forEach((li) => {
            const n = Number(li.dataset.step);
            const done = count >= n;
            li.classList.toggle('is-done', done);
            li.querySelector('.dmk-nudge__dot').innerHTML = done ? '&#10003;' : String(n);
          });
          requestAnimationFrame(() => this.measure());
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dmk-multibuy-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dmk-multibuy')) {
    customElements.define(
      'dmk-multibuy',
      class DmkMultibuy extends HTMLElement {
        connectedCallback() {
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const data = event && event.data;
            if (!data || data.sectionId !== this.dataset.section || !data.variant) return;
            this.update(data.variant.price);
          });
        }
        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
        }
        update(price) {
          const pcts = [0, Number(this.dataset.pct1), Number(this.dataset.pct2)];
          this.querySelectorAll('[data-dmk-each]').forEach((el) => {
            const pct = pcts[Number(el.dataset.dmkEach)] || 0;
            const rupees = Math.round((price * (100 - pct)) / 10000);
            el.textContent = rupees.toLocaleString('en-US');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
